'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
require('backbone.stickit');
require('bootstrap-material-design');
const ReadMore = require('common/ui/view/behavior/readmore');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const ActionHistoryRepository = require('process/domain/repository/action/history');
const EmptyItem = require('common/ui/view/empty-item');
const Template = require('process/ui/template/action/history.hbs');
const Marked = require('balus/util/marked');

const ItemView = Mn.View.extend({
    template: Template,
    className: 'list-item',
    tagName: 'li',
    modelEvents: {
        'change': 'render'
    },
    regions: {
        updatedBy: '.updatedBy'
    },
    templateContext: function() {
        const assignees = this.model.getAssignees();
        const desc = this.model.getDescription();
        return {
            path: this.model.path(),
            state: this.model.getCurrentState().toJSON(),
            assignees: assignees ? _.map(assignees, a => a.toJSON()) : null,
            description: desc ? Marked()(desc) : ''
        }
    },

    onRender: function() {
        const updatedBy = this.model.getUpdatedBy();
        if(updatedBy) {
            this.showChildView('updatedBy', new GroupMemberNameView({model: updatedBy}));
        }
    },
});

module.exports = Mn.CollectionView.extend({
    childView: ItemView,
    emptyView: EmptyItem,
    emptyViewOptions: function() {
        return {
            isList: true,
            title: i18n.t('process:action-list.no-child')
        };
    },
    tagName: 'ul',
    className: 'list',
    reorderOnSort: true,
    collectionEvents: {
        'change:point': 'reorder'
    },
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                return ActionHistoryRepository.find(this.model).hasNext();
            },
            onReadMore: function() {
                ActionHistoryRepository.find(this.model).getNext(5);
            }
        }
    },
    viewComparator: function(prev, next) {
        return - next.get('point').x + prev.get('point').x;
    }
});



// WEBPACK FOOTER //
// ./process/ui/view/action/history.js